import * as React from "react";

import { Breakpoint } from "domain/breakpoints";

export const useIsMobileViewport = () => {
    const [mediaQuery] = React.useState(() => window.matchMedia(`(max-width: ${Breakpoint.MD}px)`));
    const [isMobileViewport, setIsMobileViewport] = React.useState(mediaQuery.matches);

    React.useEffect(() => {
        const handleChange = (event: MediaQueryListEvent) => setIsMobileViewport(event.matches);
        mediaQuery.addEventListener("change", handleChange);
        return () => mediaQuery.removeEventListener("change", handleChange);
    }, [mediaQuery]);

    return isMobileViewport;
};
